// i18n area 'hci' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.cs-CZ.meta.json.
import type { enUS } from './hci'

export const csCZ: typeof enUS = {
  hci: {
    ceph: {
      title: 'Klastry Ceph',
      createButton: 'Vytvořit klastr Ceph',
      emptyTitle: 'Zatím žádný spravovaný klastr Ceph',
      emptyBody: 'TVirt nasazuje a vlastní Ceph na členských uzlech, hyperkonvergovaně s VM zátěží. Vytvořte klastr: první monitor a jeho manager se zrodí automaticky na zvoleném řídicím uzlu — pak jej rozšiřte o další monitory a zařízení OSD.',
      pageTitle: 'Klastry Ceph',
      colState: 'Stav',
      colMembers: 'Členové',
      colSize: 'Velikost',
      colVersion: 'Verze Ceph',
      sizeCell: '{used} GiB použito z {total} GiB celkem',
      phase: {
        'not-deployed': 'Nenasazený',
        deploying: 'Nasazování',
        healthy: 'Zdravý',
        degraded: 'Degradovaný',
        error: 'Chyba',
        destroying: 'Ničení',
        destroyed: 'Zničený'
      },
      health: {
        HEALTH_OK: 'Zdravý (HEALTH_OK)',
        HEALTH_WARN: 'S varováními (HEALTH_WARN)',
        HEALTH_ERR: 'Chyba (HEALTH_ERR)',
        unknown: 'Zatím nepozorováno',
        observedAt: 'pozorováno {time}'
      },
      create: {
        title: 'Vytvořit klastr Ceph',
        info: 'Při vytváření nového klastru Ceph se volí první uzel, na který se nainstalují role MON a MGR. Je také třeba určit, kterou podsíť použít pro provoz Ceph: podsíť public se používá pro obecný síťový provoz, zatímco podsíť cluster slouží interním replikám mezi OSD; různé podsítě nejsou nutně potřeba.',
        controlNode: 'Řídicí uzel',
        controlNodeHint: 'Členský uzel, kde se zrodí první MON + MGR.',
        publicSubnet: 'Podsíť public',
        publicSubnetHint: 'Subnet registrovaná v IPAM — public_network Cephu. Po vytvoření neměnná.',
        clusterSubnet: 'Podsíť cluster',
        clusterSubnetHint: 'Subnet registrovaná v IPAM — cluster_network Cephu (replikace/backfill).',
        noSubnets: 'Žádná Subnet není registrována — nejprve je vytvořte v IPAM',
        sameSubnet: 'Stejná podsíť pro provoz public i cluster',
        sameSubnetHint: 'Zaškrtnuto = síť cluster (replikace/backfill) splývá s public. Nezaškrtnuto = zvolte její vlastní podsíť A adresu řídicího uzlu v ní.',
        controlAddress: 'Adresa řídicího uzlu',
        controlAddressHint: 'Adresa, kterou IPAM zná pro tento uzel v podsíti public.',
        controlClusterAddress: 'Adresa cluster řídicího uzlu',
        controlClusterAddressHint: 'Adresa, kterou IPAM zná pro tento uzel v podsíti cluster.',
        noAddresses: 'IPAM nezná žádnou adresu tohoto uzlu ve zvolené podsíti',
        started: 'Klastr vytvořen — bootstrap pokračuje jako makroúloha; fáze se aktualizuje sama',
        error: 'Klastr byl odmítnut'
      },
      detail: {
        actions: 'Dostupné akce',
        tabOverview: 'Přehled',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pooly',
        tabObjects: 'Objekty',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Pokročilé',
        phase: 'Fáze',
        checksTitle: 'Aktivní kontroly zdraví',
        noChecks: 'Žádná aktivní kontrola zdraví',
        checkMuted: 'ztlumený',
        summaryPools: 'Pooly',
        summaryFilesystems: 'Filesystemy',
        nodesCard: 'Uzly',
        monHint: 'S každým MON běží kolokovaný MGR. Tři MON jsou doporučené kvorum; laboratorní klastr startuje s jedním. OSD a MDS žijí na svých kartách.',
        monHintSplit: 'MON a MGR jsou na tomto klastru oddělené (Pokročilé): každá role je vlastní membership po uzlech. Tři MON jsou doporučené kvorum; alespoň jeden MGR musí existovat.',
        noMons: 'Žádný monitor není deklarován',
        addNode: 'Přidat uzel',
        removeNode: 'Odebrat uzel',
        removeNodeFrom: 'Odebrat uzel {node} (jeho MON a kolokovaný MGR)',
        roleMon: 'Role MON',
        roleMgr: 'Role MGR',
        roleNa: 'N/A',
        roleNotObserved: 'zatím nepozorováno',
        monInQuorum: 'v kvoru',
        monOutQuorum: 'mimo kvorum',
        mgrActive: 'aktivní',
        mgrStandby: 'standby',
        addRoleMon: 'Přidat roli MON',
        removeRoleMon: 'Odebrat roli MON',
        addRoleMgr: 'Přidat roli MGR',
        removeRoleMgr: 'Odebrat roli MGR',
        restartMon: 'Restartovat službu MON',
        restartMgr: 'Restartovat službu MGR',
        addMon: 'Přidat MON',
        removeMon: 'Odebrat MON',
        removeMonFrom: 'Odebrat roli MON z {node}',
        addMgr: 'Přidat MGR',
        removeMgr: 'Odebrat MGR',
        removeMgrFrom: 'Odebrat roli MGR z {node}',
        addMds: 'Přidat MDS',
        removeMds: 'Odebrat MDS',
        removeMdsFrom: 'Odebrat roli MDS z {node}',
        mdsSection: 'Servery metadat (MDS)',
        noMds: 'Žádný MDS není deklarován — filesystem nejprve nějaký potřebuje',
        mdsHint: 'Membership MDS je vlastní od prvního dne: klastr bez CephFS žádnou nedeklaruje, jeden aktivní plus jeden standby obslouží filesystem dobře. Ceph volí aktivní a standby mezi deklarovanými daemony.',
        mdsActiveFor: 'aktivní — {fs}',
        mdsNotObserved: 'zatím nepozorován',
        lastMdsGuard: 'Poslední MDS nelze odebrat, dokud existuje filesystem — nejprve odeberte filesystemy',
        lastMonGuard: 'Poslední MON nelze odebrat — jediným východiskem je zničit klastr',
        lastMgrGuard: 'Poslední MGR nelze odebrat — spravovaný klastr nikdy neběží bez manageru',
        registerDevice: 'Přidat OSD',
        unregisterDevice: 'Odregistrovat',
        activeDeviceGuard: 'Aktivní OSD — odchází přes životní cyklus OSD, ne přes evidenci',
        colNode: 'Uzel',
        devicePhase: { registered: 'Registrováno', active: 'Aktivní' },
        health: 'Zdraví',
        state: 'Stav',
        fsid: 'fsid',
        fsidPending: 'chybí — zopakujte bootstrap',
        version: 'Verze Ceph',
        publicNetwork: 'Síť public',
        clusterNetwork: 'Síť cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'V této fázi není dostupná žádná akce',
        destroyedNote: 'Klastr zničen — řádek bude zanedlouho automaticky odstraněn'
      },
      overview: {
        services: 'Služby',
        ok: 'v pořádku',
        warning: 'warning',
        down: 'mimo provoz',
        pgTitle: 'Stavy PG',
        pgTotal: '{n} PG celkem',
        capacityTitle: 'Prostor',
        ioTitle: 'Aktuální I/O',
        ioReadBw: 'Propustnost čtení',
        ioWriteBw: 'Propustnost zápisu',
        ioReadIops: 'IOPS čtení',
        ioWriteIops: 'IOPS zápisu',
        notObserved: 'zatím nepozorováno'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Stav',
        colSize: 'Velikost',
        colPgs: 'PG',
        empty: 'Žádný OSD — přidejte jeden z deklarovaného datového disku',
        markIn: 'Označit IN',
        markOut: 'Označit OUT',
        scrub: 'Spustit scrub',
        deepScrub: 'Spustit hluboký scrub',
        restart: 'Restartovat službu',
        details: 'Detaily',
        actionGuard: 'Pouze na aktivním OSD nasazeného klastru',
        inTitle: 'Označit OSD IN',
        inBody: 'osd.{id} se vrací do rozmístění dat (ceph osd in): Ceph na něj data rebalancuje zpět.',
        outTitle: 'Označit OSD OUT',
        outBody: 'osd.{id} opouští rozmístění dat (ceph osd out): jeho data se rebalancují jinam a redundance je SNÍŽENÁ, dokud běží backfill. Kdykoli vratné pomocí Označit IN.',
        scrubTitle: 'Naplánovat scrub',
        scrubBody: 'Naplánuje se scrub osd.{id}: mon jej zařadí do fronty a výsledek ukážou stavy PG dalších sweepů.',
        deepScrubTitle: 'Naplánovat hluboký scrub',
        deepScrubBody: 'Naplánuje se hluboký scrub osd.{id}: varianta ověřující bajty — těžší na I/O, stejná mechanika.',
        restartTitle: 'Restartovat službu OSD',
        restartBody: 'osd.{id} se zastaví a znovu spustí přes vlastní supervizi workeru na jeho uzlu.',
        started: 'Akce spuštěna — pozorování se aktualizuje samo',
        error: 'Akce OSD byla odmítnuta'
      },
      osdDetail: {
        title: 'Detaily OSD',
        tabGeneral: 'Obecné',
        tabNetwork: 'Síť',
        tabDevices: 'Zařízení',
        version: 'Verze',
        hostname: 'Hostname',
        dataPath: 'Cesta k datům OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Šifrováno',
        yes: 'Ano',
        no: 'Ne',
        memory: 'Využití paměti (PSS)',
        pid: 'Process ID (PID)',
        front: 'Adresa front (klient & monitor)',
        hbFront: 'Adresa heartbeat front',
        back: 'Adresa back (OSD)',
        hbBack: 'Adresa heartbeat back',
        colDevice: 'Device',
        colType: 'Typ',
        colPhysical: 'Fyzický device',
        colSize: 'Velikost',
        volumeTitle: 'Detaily svazku',
        creationTime: 'Datum vytvoření',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Pro tento OSD nebyl pozorován žádný device'
      },
      restart: {
        title: 'Restartovat službu',
        monBody: 'Daemon MON na {node} se zastaví a znovu spustí přes vlastní supervizi workeru.',
        mgrBody: 'Daemon MGR na {node} se zastaví a znovu spustí přes vlastní supervizi workeru.',
        started: 'Restart spuštěn — pozorování se aktualizuje samo',
        error: 'Restart byl odmítnut'
      },
      encryptionMode: {
        alwaysOn: 'Vždy povoleno (dmcrypt)',
        alwaysOff: 'Vždy zakázáno',
        perOsd: 'Volí se u každého OSD',
        section: 'Šifrování OSD at rest',
        title: 'Změnit režim šifrování OSD',
        hint: 'Jak se připravují NOVÉ OSD. Stávající OSD si drží svůj stav per disk: pro změnu OSD odeberte a vytvořte znovu.',
        body: 'Režim se změní na "{mode}" a platí POUZE pro NOVÉ OSD: každý stávající OSD si drží svůj aktuální stav šifrování.',
        apply: 'Změnit režim',
        error: 'Změna režimu byla odmítnuta'
      },
      pin: {
        address: 'Adresa public (volitelný pin)',
        clusterAddress: 'Adresa cluster (volitelný pin)',
        autoPlaceholder: 'automaticky v podsíti {cidr}',
        hint: 'Adresace per daemon: prázdné = Ceph se naváže sám uvnitř deklarované sítě; vyplněné = tato instance daemonu je připnutá na adresu ve své sekci conf.'
      },
      addMon: {
        title: 'Přidat uzel',
        node: 'Uzel',
        address: 'Adresa public',
        addressHint: 'Adresy uzlu, které IPAM zná v podsíti public — automatické, když uzel pokrývá existující deklarace.',
        clusterAddress: 'Adresa cluster',
        clusterAddressHint: 'Povinné: podsíť cluster je oddělená a uzel na ní ještě není deklarován.',
        noAddresses: 'IPAM nezná žádnou adresu tohoto uzlu v této podsíti',
        error: 'Přidání monu bylo odmítnuto'
      },
      removeMon: {
        title: 'Odebrat MON',
        body: 'MON a jeho kolokovaný MGR opouštějí uzel {node}. Na nasazeném klastru se daemony zastaví a odeberou z kvora.',
        error: 'Odebrání MON bylo odmítnuto'
      },
      addMgr: {
        title: 'Přidat MGR',
        node: 'Uzel',
        hint: 'Pokročilé (oddělené MON/MGR): samostatný manager se zrodí na zvoleném členském uzlu úlohou vázanou na uzel. Vlastní volba active/standby Cephu si aktivní MGR vybere sama.',
        error: 'Přidání MGR bylo odmítnuto'
      },
      removeMgr: {
        title: 'Odebrat MGR',
        body: 'Samostatný MGR opouští uzel {node}. Na nasazeném klastru se daemon zastaví a jeho stav odstraní; MON uzlu (pokud existuje) zůstává nedotčen.',
        error: 'Odebrání MGR bylo odmítnuto'
      },
      addMds: {
        title: 'Přidat MDS',
        node: 'Uzel',
        hint: 'Server metadat pro CephFS: zrodí se na zvoleném členském uzlu úlohou vázanou na uzel, pod dohledem workeru jako MON a MGR. Ceph si aktivní a standby volí sám — jeden aktivní plus jeden standby obslouží filesystem dobře.',
        error: 'Přidání MDS bylo odmítnuto'
      },
      removeMds: {
        title: 'Odebrat MDS',
        body: 'MDS opouští uzel {node}. Na nasazeném klastru se daemon zastaví a jeho stav odstraní; API odmítá poslední MDS, dokud jej filesystem potřebuje.',
        error: 'Odebrání MDS bylo odmítnuto'
      },
      split: {
        title: 'Oddělené MON/MGR',
        label: 'Povolit MON a MGR na disjunktních uzlech',
        hint: 'Vypnuto (výchozí) = ratifikovaný standard: s každým MON běží kolokovaný MGR, jediná membership. Zapnuto = membership MGR se osamostatní, spravuje se akcemi Přidat/Odebrat MGR na kartě Uzly správy.',
        enable: 'Zapnout',
        disable: 'Vypnout',
        enableBody: 'Membership MGR se stane nezávislou na MON, inicializovaná ze současné kolokace. Akce Přidat/Odebrat MGR se aktivují na kartě Uzly správy. Toto uvolňuje výchozí nastavení platformy — ponechte je, jen pokud víte, proč je potřebujete.',
        disableBody: 'Návrat ke standardní kolokaci: MGR s každým MON, jediná membership. Legální, jen pokud membership MGR už splývá s MON — nejprve ji srovnejte akcemi Přidat/Odebrat MGR, jinak API odmítne.',
        error: 'Změna byla odmítnuta'
      },
      rawEditor: {
        title: 'Surový editor CRUSH',
        label: 'Zobrazit surový editor crushmapy na kartě CRUSH',
        hint: 'Vypnuto (výchozí) = standardním nástrojem je řízený povrch pravidel. Zapnuto = karta CRUSH ukazuje i dekompilovanou crushmapu jako upravitelný text. Uložení vždy vyžaduje sudo, název klastru jako potvrzení, a projde přes compile + test crushtoolu DŘÍV, než dosáhne klastru.'
      },
      osdFlags: {
        section: 'Globální příznaky OSD',
        title: 'Override příznaků OSD',
        notObserved: 'zatím nepozorovány',
        standardFlowsHint: 'Standardní toky platformy spravují tyto příznaky samy v běžných případech (údržba uzlu nastaví cílený noout, výměna disku jde přes životní cyklus OSD). Tato sekce je ruční override pro operátora, který ví, co dělá.',
        notDeployedGuard: 'Příznaky OSD existují jen na nasazeném klastru',
        set: 'Nastavit příznak',
        unset: 'Odebrat příznak',
        setBody: 'Globální příznak {flag} bude NASTAVEN na osdmapě. Zůstává, dokud není explicitně odebrán — zapomenutý příznak degraduje samoléčení klastru.',
        unsetBody: 'Globální příznak {flag} bude ODEBRÁN z osdmapy.',
        error: 'Změna příznaku byla odmítnuta',
        flag: {
          noout: 'Žádný OSD se neoznačuje out z rozmístění dat — žádné rebalancování při ztrátě daemonu',
          norebalance: 'Rebalancování dat je pozastaveno',
          nobackfill: 'Backfill je pozastaven',
          norecover: 'Recovery je pozastaveno',
          pause: 'VEŠKERÉ klientské I/O je pozastaveno (čtení i zápisy)',
          noin: 'Startující OSD se automaticky neoznačují in',
          nodown: 'Nedostupné OSD se neoznačují down — maskuje skutečné výpadky'
        }
      },
      pools: {
        section: 'Pooly',
        create: 'Vytvořit pool',
        createGuard: 'Pooly existují jen na nasazeném klastru',
        notObserved: 'Zatím žádné pozorování poolů — hlásí sem sweep monu',
        empty: 'Na klastru zatím žádný pool',
        colName: 'Název',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplikace',
        colRule: 'Pravidlo CRUSH',
        colUsage: 'Využití',
        observedAtLabel: 'Pozorováno',
        objects: 'objektů: {n}',
        inUseBy: 'používá jej {name}',
        internalGuard: 'Interní pool Cephu — platforma jej nikdy neodstraní',
        delete: 'Odstranit pool',
        deleteGuard: 'Konzumuje ho úložiště {name} — nejprve odstraňte úložiště',
        hint: 'Pouze replikované pooly (erasure coding je mimo scope v1). Replikace žije v Cephu: tato tabulka je pozorovaná pravda ze sweepu monu.',
        createTitle: 'Vytvořit pool',
        createHint: 'Pool se zrodí na klastru s požadovanou replikací a zapnutou aplikací rbd — práci odvede úloha na uzlu MON. Zapněte "Navrhnout jako úložiště", abyste jej rovnou stejným gestem konzumovali.',
        name: 'Název poolu',
        nameHint: 'DNS-safe (malá písmena, číslice, pomlčky).',
        size: 'Repliky (size)',
        sizeHint: 'Kopie každého objektu. Výchozí 3.',
        minSize: 'Minimum replik (min_size)',
        minSizeHint: 'Minimum kopií pro obsluhu I/O — sleduje size − 1, dokud jej neupravíte.',
        createError: 'Vytvoření poolu bylo odmítnuto',
        deleteTitle: 'Odstranit pool',
        deleteBody: 'Pool {pool} a KAŽDÝ objekt v něm budou nevratně zničeny. Pro potvrzení napište název poolu.',
        confirmLabel: 'Název poolu',
        confirmHint: 'Pro potvrzení napište název poolu',
        deleteError: 'Odstranění poolu bylo odmítnuto',
        detailTitle: 'Detaily poolu',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Zapnuto',
        autoscalerOff: 'Vypnuto',
        autoscalerWarn: 'Upozornit',
        pgNumLabel: 'Počet PG',
        pgNumCaption: 'Pozorováno: autoscaler jej může měnit sám — toto pole zapisuje přání.',
        storage: 'Přidružené úložiště TVirt',
        addAsStorage: 'Přidat jako úložiště TVirt',
        ruleSudoHint: 'Změna pravidla CRUSH vyžaduje heslo operátora.',
        updateError: 'Úprava poolu byla odmítnuta',
        updated: 'Úprava poolu spuštěna — pozorování se aktualizuje samo'
      },
      crush: {
        section: 'Pravidla CRUSH',
        notObserved: 'Zatím žádné pozorování CRUSH — hlásí sem sweep monu',
        empty: 'Na klastru nebylo pozorováno žádné pravidlo',
        hint: 'Pravidlo rozhoduje, KAM dopadnou kopie každého objektu — jeho doména selhání je jednotka, která smí selhat bez ztráty dat. Pooly ukazují na pravidlo; builtin replicated_rule (jedna replika na server) je výchozí od zrodu.',
        create: 'Vytvořit pravidlo',
        createGuard: 'Pravidla CRUSH existují jen na nasazeném klastru',
        createTitle: 'Vytvořit pravidlo CRUSH',
        createHint: 'Jedno pravidlo = jedna volba domény selhání. Pravidlo se zrodí replikované na výchozím rootu — práci odvede úloha na uzlu MON; pooly přidružte poté z karty Pooly.',
        createError: 'Vytvoření pravidla bylo odmítnuto',
        name: 'Název pravidla',
        nameHint: 'DNS-safe (malá písmena, číslice, pomlčky).',
        domain: 'Doména selhání',
        domainChoice: {
          osd: 'Každá replika na jiném OSD',
          host: 'Každá replika na jiném serveru',
          rack: 'Každá replika v jiném racku'
        },
        domainCustom: 'Vlastní (ručně psané kroky)',
        domainOther: 'Každá replika v jiném {type}',
        rackGuardHint: 'V pozorované hierarchii neexistuje žádný bucket rack: pravidlo lze přesto vytvořit, ale žádný pool na něj nepůjde nasměrovat, dokud nebude rack deklarován v umístění členských serverů (nastavení uzlu) — úloha srovnání postaví bucket a přidružení se otevře samo.',
        treeTitle: 'Pozorovaná hierarchie',
        treeNotObserved: 'Zatím žádné pozorování hierarchie — hlásí sem sweep monu',
        treeOsds: '{n} OSD',
        treeHint: 'Mapa CRUSH, jak ji vidí klastr: root → deklarované úrovně → servery (host) → OSD. Topologie sleduje deklarované umístění každého serveru (nastavení uzlu) — změna umístění ji srovná úlohou.',
        unplacedWarning: 'Členové bez deklarovaného umístění: {nodes} — jejich host buckety zůstávají přímo pod rootem, mimo deklarovanou topologii. Deklarujte umístění v nastavení uzlu (varování, nikdy blokace).',
        colName: 'Název',
        colDomain: 'Doména selhání',
        colPools: 'Pooly',
        builtinChip: 'builtin',
        builtinGuard: 'Výchozí pravidlo klastru — platforma je nikdy neodstraní',
        detailAction: 'Detail pravidla',
        detailType: 'Typ',
        backToRules: 'Pravidla',
        ruleNotObserved: 'Pozorovaný seznam pravidel toto pravidlo nejmenuje',
        noPools: 'Na tomto pravidle nejede žádný pool',
        delete: 'Odstranit pravidlo',
        deleteTitle: 'Odstranit pravidlo CRUSH',
        deleteBody: 'Pravidlo {rule} se odstraní z crushmapy klastru. Nesmí na něm jet žádný pool. Pro potvrzení napište název pravidla.',
        deleteGuard: 'Jede na něm pool {name} — nejprve pool přesměrujte',
        confirmLabel: 'Název pravidla',
        confirmHint: 'Pro potvrzení napište název pravidla',
        deleteError: 'Odstranění pravidla bylo odmítnuto',
        changeRule: 'Změnit pravidlo CRUSH',
        changeRuleTitle: 'Změnit pravidlo CRUSH',
        changeRuleHint: 'Pool začne umisťovat své objekty podle zvoleného pravidla — Ceph přesune existující data, aby vyhověl (na plném poolu následuje rebalancování).',
        changeRuleError: 'Změna pravidla byla odmítnuta',
        rule: 'Pravidlo CRUSH',
        rawTitle: 'Surová crushmapa (dekompilovaná)',
        rawWarning: 'NEBEZPEČÍ: tento text je CELÁ politika umisťování klastru. Špatná mapa může rozbít placement všech poolů najednou. Uložení mapu zkompiluje a otestuje crushtoolem DŘÍV, než ji vstříkne — ale i validní mapa může být špatný nápad.',
        rawReload: 'Znovu načíst',
        rawLoading: 'Dotaz v letu — read-only úloha dekompiluje crushmapu…',
        rawSave: 'Uložit crushmapu',
        rawSaveTitle: 'Vstříknout crushmapu',
        rawSaveBody: 'Upravený text nahradí crushmapu CELÉHO klastru po compile + testu crushtoolu. Pro potvrzení napište název klastru.',
        rawConfirmLabel: 'Název klastru',
        rawConfirmHint: 'Pro potvrzení napište {name}',
        rawError: 'Operace nad crushmapou selhala',
        rawHint: 'Text je forma crushtool -d. Chyby kompilace i testu se vracejí doslova z crushtoolu — pokud jedna z obou bran selže, mapa se ke klastru nikdy nedostane.'
      },
      objects: {
        poolsSection: 'Průzkumník objektů',
        poolsHint: 'Vyberte pool a nechte si vypsat jeho obrazy RBD. Každé hluboké čtení běží jako read-only úloha na uzlu MON — neblokuje (ani není blokováno) skutečné operace.',
        deployedGuard: 'Dotazy na objekty odpovídají jen na nasazeném klastru',
        browse: 'Procházet objekty',
        detailAction: 'Detail obrazu',
        backToPools: 'Pooly',
        backToImages: 'Obrazy',
        refresh: 'Aktualizovat',
        loading: 'Dotaz v letu — read-only úloha se dotazuje klastru…',
        error: 'Dotaz selhal',
        retry: 'Zkusit znovu',
        notRbd: 'Pool s application "{app}" — neobsahuje obrazy RBD, není zde co prozkoumávat',
        noImages: 'V tomto poolu nejsou žádné obrazy RBD',
        colImage: 'Obraz',
        colSize: 'Velikost',
        colObjects: 'Objekty',
        colSnapshots: 'Snímky',
        imagesHint: 'Disky na konzumujícím úložišti rbd jsou obrazy pojmenované podle id svého disku. Počet objektů je provisioned (velikost / velikost objektu) — skutečné využití žije v detailu obrazu.',
        infoTitle: 'Obraz',
        infoSize: 'Virtuální velikost',
        infoObjects: 'Objekty (provisioned)',
        infoObjectSize: 'Velikost objektu',
        infoPrefix: 'Prefix objektů',
        infoFormat: 'Formát',
        infoFeatures: 'Features',
        usageTitle: 'Skutečné využití (rbd du)',
        usageOf: 'z {provisioned} GiB provisioned',
        usageHint: 'Thin od přírody: bajty zabírají jen zapsané objekty.',
        watchersTitle: 'Watchery',
        noWatchers: 'Žádný watcher — nikdo nemá tento obraz právě otevřený',
        snapshotsTitle: 'Snímky RBD',
        noSnapshots: 'Na tomto obrazu není žádný snímek RBD',
        colSnapshot: 'Snímek',
        colProtected: 'Chráněn',
        colTimestamp: 'Vytvořen',
        protected: 'chráněn',
        mappingTitle: 'Fyzické umístění (množina OSD)',
        mappingSampled: 'Vzorek {sampled} objektů z {total} — poctivé shrnutí: u velkých obrazů množina konverguje ke VŠEM OSD poolu (CRUSH rozprostírá objekty po celém poolu).',
        mappingComplete: 'Zmapovány všechny objekty ({total} z {total}).',
        objectQueryTitle: 'Zmapovat jediný objekt',
        objectName: 'Název objektu',
        objectHint: 'Názvy objektů RADOS jsou <prefix>.<index 16-hex> — ceph osd map odpoví PG a trojicemi OSD.',
        mapObject: 'Zmapovat',
        primary: 'primární: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrovat zařízení OSD',
        hint: 'Na živém klastru registrace zařízení také PŘIPRAVÍ: stane se z něj OSD BlueStore automatickou úlohou vázanou na uzel (nikdy prázdná, ratifikováno 2026-07-24). Zařízení patří nejvýše jednomu klastru Ceph v celé flotile.',
        disk: 'Datový disk',
        diskHint: 'Deklarované datové disky uzlu — název a pin sériového čísla',
        noDeclared: 'Na tomto uzlu není deklarován žádný datový disk — nejprve je označte v lokálních nastaveních uzlu',
        serialHint: 'Sériové číslo zařízení — pin identity',
        encrypted: 'Šifrovat tento OSD (dmcrypt)',
        encryptedHint: 'Volba per OSD (režim klastru je "volí se u každého OSD"): zmrazí se na tomto disku při registraci — pozdější změna režimu ji nikdy nepřepíše; to dělá řádková akce šifrovat/dešifrovat.',
        error: 'Registrace byla odmítnuta'
      },
      unregisterDevice: {
        title: 'Odregistrovat zařízení',
        body: 'Pouze evidence: {name} přestává být kandidátem na OSD tohoto klastru. Jeho bajtů se nikdo nedotkne.',
        error: 'Odregistrace byla odmítnuta'
      },
      deploy: {
        action: 'Zopakovat nasazení',
        title: 'Zopakovat bootstrap',
        body: 'Zrodový bootstrap se znovu rozběhne ze současné konfigurace: mony se spustí, každé registrované zařízení se připraví a aktivuje jako OSD BlueStore. Operace běží jako makroúloha — fáze se aktualizuje sama.',
        started: 'Bootstrap spuštěn — pokračuje jako makroúloha; fáze se aktualizuje sama',
        error: 'Bootstrap byl odmítnut'
      },
      propose: {
        action: 'Navrhnout jako úložiště',
        title: 'Navrhnout jako úložiště',
        hintPool: 'Existující pool {name} se stane úložištěm TVirt: identita cephx omezená na pool skončí v keystore a úložiště ceph-rbd se zrodí připravené. Návrh pool konzumuje — nikdy žádný nevytváří.',
        hintFs: 'Existující filesystem {name} se stane úložištěm TVirt: identita cephx omezená na filesystem skončí v keystore a úložiště cephfs se zrodí připravené a připojené. Návrh filesystem konzumuje — nikdy žádný nevytváří.',
        name: 'Název úložiště',
        nameHint: 'DNS-1123, jedinečný ve scope — identita cephx se jmenuje po něm.',
        path: 'Path uvnitř filesystemu',
        pathHint: 'Absolutní path uvnitř filesystemu, který úložiště připojuje — / v pochybnostech.',
        alsoPropose: 'Rovnou navrhnout jako úložiště',
        alsoProposePoolHint: 'Po vytvoření stejné gesto navrhne čerstvě zrozený pool jako úložiště ceph-rbd — dvě explicitní volání, jeden dialog.',
        alsoProposeFsHint: 'Po vytvoření stejné gesto navrhne čerstvě zrozený filesystem jako úložiště cephfs — dvě explicitní volání, jeden dialog.',
        guard: 'Navrhnout jako úložiště — jen na healthy klastru',
        started: 'Návrh přijat — úložiště se materializuje; najdete jej pod Úložiště',
        submit: 'Vytvořit úložiště',
        error: 'Návrh byl odmítnut'
      },
      fs: {
        section: 'Filesystemy',
        create: 'Vytvořit filesystem',
        createGuard: 'Filesystemy existují jen na nasazeném klastru',
        mdsFirstGuard: 'Nejprve přidejte MDS — filesystem bez serveru metadat se rodí neobsluhovatelný',
        notObserved: 'Zatím žádné pozorování filesystemů — hlásí sem sweep MON',
        empty: 'Na klastru zatím žádný filesystem',
        colName: 'Název',
        colPools: 'Pooly',
        colMds: 'MDS',
        noActiveMds: 'žádný aktivní MDS',
        delete: 'Odebrat filesystem',
        deleteGuard: 'Konzumuje ho úložiště {name} — nejprve odstraňte úložiště',
        hint: 'Filesystem vlastní své pooly pro data a metadata (cephfs.<název>.data / .meta): rodí se s ním a umírají s ním — removeFs, nikdy holé odstranění poolu. Tato tabulka je pozorovaná pravda ze sweepu MON.',
        createTitle: 'Vytvořit filesystem',
        createHint: 'Filesystem se zrodí na klastru se svými dvěma pooly (application cephfs) a obsluhují ho deklarované MDS — práci odvede úloha na uzlu MON. Zapněte "Navrhnout jako úložiště", abyste jej rovnou stejným gestem konzumovali.',
        name: 'Název filesystemu',
        nameHint: 'DNS-safe (malá písmena, číslice, pomlčky).',
        sizeHint: 'Repliky OBOU nově zrozených poolů. Výchozí 3.',
        createError: 'Vytvoření filesystemu bylo odmítnuto',
        deleteTitle: 'Odebrat filesystem',
        deleteBody: 'Filesystem {fs} a KAŽDÝ soubor v něm budou nevratně zničeny — jeho pooly pro data a metadata umírají s ním. Pro potvrzení napište název filesystemu.',
        confirmLabel: 'Název filesystemu',
        confirmHint: 'Pro potvrzení napište název filesystemu',
        deleteError: 'Odebrání filesystemu bylo odmítnuto'
      },
      destroy: {
        action: 'Zničit',
        retryAction: 'Zopakovat zničení',
        retryGuard: 'Zničení právě běží — opakování platí pro selhalé zničení (jinak je lease odmítne)',
        title: 'Zničit klastr',
        body: 'Nasazený fabric se rozebere: každý daemon tohoto klastru se zastaví, jeho systémový stav a klíče v keystore se uvolní. Po úspěšném zničení je klastr odstraněn automaticky.',
        confirmLabel: 'Název klastru',
        confirmHint: 'Pro potvrzení napište název klastru',
        wipe: 'Vymazat registrovaná zařízení',
        wipeHint: 'Zaškrtnuto: podpisy každého registrovaného zařízení se vymažou — data na nich jsou zničena. Nezaškrtnuto: bajty zůstanou nedotčené a zařízení se vrátí mezi registrovaná.',
        guard: 'Zničit — nic není nasazeno',
        started: 'Zničení spuštěno — pokračuje jako makroúloha; fáze se aktualizuje sama',
        error: 'Zničení bylo odmítnuto'
      },
      delete: {
        guard: 'Odstranit — jen nenasazenou konfiguraci (nejprve zničit)',
        title: 'Odstranit {name}?',
        body: 'Konfigurace a její evidence zařízení budou odstraněny. Legální, jen dokud není nic nasazeno.',
        error: 'Odstranění bylo odmítnuto'
      }
    }
  }
}
